import { render, staticRenderFns } from "./CItemProps.vue?vue&type=template&id=541a2f07"
import script from "./CItemProps.vue?vue&type=script&lang=js"
export * from "./CItemProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports